import { css } from "@emotion/react";

import { getColor } from "./colors";
export { SPACING } from "./spacing";

export const theme = {
  font: {
    header: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 500;
      font-size: 18px;
      line-height: 18px;
      letter-spacing: 0;
    `,
    button: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0;
    `,
    body18: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0;
    `,
    body16: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0;
    `,
    body14: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0;
    `,
    body12: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.24px;
    `,
    support10: css`
      font-family: "DM Sans", sans-serif;
      font-weight: 500;
      font-size: 10px;
      line-height: 14px;
      letter-spacing: 0;
    `,
    mono12: css`
      font-family: "IBM Plex Mono", monospace;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: 0.24px;
    `,
  },
  color: getColor,
};
